import styles from './styles/style.css' assert { type: 'css' };
import Lenis from '@studio-freight/lenis'
import Swiper, { Autoplay } from 'swiper';

window.Webflow ||= [];
window.Webflow.push(() => {
  /*---------- Smooth Scroll ----------*/
  const lenis = new Lenis()

  function raf(time) {
    lenis.raf(time)
    requestAnimationFrame(raf)
  }

  requestAnimationFrame(raf)

  /*---------- Navigation Bar ----------*/
  // class NavMenu {
  //   constructor(navBarSelector) {
  //     this.navBar = document.querySelector(navBarSelector);
  //     this.menuBtn = this.navBar.querySelector('[data-role="menu button"]');
  //     this.menuLinks = this.navBar.querySelectorAll("a.nav__link");
  //     this.menuWrp = this.navBar.querySelector('[data-role="navigation menu"]');
  //     this.menuCloseBg =
  //       this.navBar.querySelector('[aria-control="close menu"]') || null;
  //     this.init();
  //   }

  //   openMenu() {
  //     this.menuBtn.classList.add("st-open");

  //     this.menuWrp.classList.add("st-visible");

  //     this.menuBtn.setAttribute("menu-state", "open");
  //     this.menuWrp.setAttribute("menu-state", "open");

  //     this.toggleMenuCloseBg(1);
  //   }

  //   closeMenu() {
  //     this.menuBtn.classList.remove("st-open");

  //     this.menuWrp.classList.remove("st-visible");

  //     this.menuBtn.setAttribute("menu-state", "closed");
  //     this.menuWrp.setAttribute("menu-state", "closed");

  //     this.toggleMenuCloseBg(0);
  //   }

  //   toggleMenuCloseBg(opacityState) {
  //     if (this.menuCloseBg) {
  //       if (opacityState === 1) {
  //         this.menuCloseBg.style.cssText = `transition: opacity 400ms ease-out; opacity: ${opacityState}; width: 100%`;
  //       } else if (opacityState === 0) {
  //         setTimeout(() => {
  //           this.menuCloseBg.style.cssText = `transition: opacity 400ms ease-out; opacity: ${opacityState};`;
  //           setTimeout(() => {
  //             this.menuCloseBg.style.width = "0%";
  //           }, 400);
  //         });
  //       }
  //     }
  //   }

  //   toggleMenu() {
  //     if (this.menuBtn.getAttribute("menu-state") === "closed") {
  //       this.openMenu();
  //     } else if (this.menuBtn.getAttribute("menu-state") === "open") {
  //       this.closeMenu();
  //     }
  //   }

  //   init() {
  //     const breakpoint = window.matchMedia("(max-width: 991px)");

  //     this.menuBtn.addEventListener("click", () => {
  //       this.toggleMenu();
  //     });
  //     this.menuLinks.forEach((link) => {
  //       link.addEventListener("click", () => {
  //         this.closeMenu();
  //       });
  //     });
  //     if (this.menuCloseBg) {
  //       this.menuCloseBg.addEventListener("click", () => {
  //         this.closeMenu();
  //       });
  //     }

  //     const breakpointChecker = () => {
  //       if (breakpoint.matches) {
  //         this.menuWrp.classList.add("mobile-menu");
  //       } else {
  //         this.menuWrp.classList.remove("mobile-menu");
  //         this.closeMenu();
  //       }
  //     };

  //     breakpoint.addListener(breakpointChecker);
  //     breakpointChecker();
  //   }
  // }

  // let nav = new NavMenu(".navigation-bar");

  /*---------- Projects Cards ----------*/
  Swiper.use([Autoplay])
  const projectCards = document.querySelectorAll('.wt--project__card')

  const initProjectImagesRotation = (swiperClass, parentCard) => {
    new Swiper(swiperClass, {
      wrapperClass: 'wt--project__slider--track',
      slideClass: 'wt--project__slider--slide',
      direction: 'horizontal',
      speed: 1,
      centeredSlides: false,
      slidesPerView: 'auto',
      spaceBetween: '0%',
      allowTouchMove: false,
      autoplay: {
        delay: 1000,
      },
      on: {
        afterInit: function () {
          this.autoplay.stop()
          parentCard.addEventListener('mouseenter', () => this.autoplay.start())
          parentCard.addEventListener('mouseleave', () => {
            this.autoplay.stop()
            this.slideTo(0, 1)
          })
        }
      }
    })
  }

  projectCards.forEach((card, i) => {
    card.querySelector('.wt--project__slider').classList.add(`card-slider-${i}`)
    initProjectImagesRotation(`.card-slider-${i}`, card)
  });

  /*------------ Footer -----------*/
  const footerSpacer = document.querySelector('.wt--pre-footer')
  const footer = document.querySelector('.wt--footer')
  const setFooterSpacerHight = () => {
    footerSpacer.style.height = `${footer.offsetHeight}px`
  }

  window.onload = setFooterSpacerHight
  window.onresize = setFooterSpacerHight

  /*------------ Modal -----------*/
  const modalWrp = document.querySelectorAll('.wt--contact-modal__wrp')
  const modalButtons = document.querySelectorAll('.wt--btn.btn--contact')
  const modalClose = document.querySelectorAll('[wt-contact-modal="close"]')

  const toggleModalBehaviour = () => {
    modalWrp.forEach(modal => {
      if (modal.getAttribute('wt-contact-modal-state') === 'hidden') {
        modal.setAttribute('wt-contact-modal-state', 'visible')
        document.body.style.overflow = 'hidden'
        lenis.stop()
      } else {
        modal.setAttribute('wt-contact-modal-state', 'hidden')
        document.body.style.overflow = 'auto'
        lenis.start()
      }
    })
  }

  modalButtons.forEach(btn => {
    btn.addEventListener('click', toggleModalBehaviour)
  })

  modalClose.forEach(btn => {
    btn.addEventListener('click', toggleModalBehaviour)
  })
})